<template>
  <div style="width: 100%">
    <Breadcrumb></Breadcrumb>
    <div class="withdrawal line-height-40">
      <div class="common-limit">
        <el-card style="margin: 0 0 12px 0">
          <el-form label-position="right" label-width="100px">
            <el-form-item label="支付类型：">
              增值服务-绑定独立域名
            </el-form-item>
            <el-form-item label="绑定域名：" prop="busiDomain">
              <el-input
                style="width: 500px; padding-top: -10px; margin: 0 8px 0 0"
                placeholder="请输入域名"
                v-model="saveParams.busiDomain"
                size="small"
              />
            </el-form-item>
            <el-form-item label="支付方式：">
              <el-radio-group v-model="withdrawType">
                <el-radio :label="'alipay'">用户余额</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="message">
              <div style="display:inline-block;margin: 0 32px 0 0;">
                支付账户：<span v-if="user.nickName"
                  >{{ user.userName }}（{{ user.nickName }}）</span
                ><span v-else>{{ user.userName }}</span>
              </div>
              <div style="display:inline-block;margin: 0 32px 0 0;">
                可用余额：<span style="color: #f05f6b">{{ user.balance }}</span>
                元
              </div>
              <div style="display:inline-block;margin: 0 32px 0 0;">
                <a @click="handleJump('/system/account/recharge')">充值</a>
              </div>
            </div>
            <el-form-item label="应付金额：" prop="amount">
              <span style="color: #f05f6b;font-size:19px;font-weight:bold;"
                >{{ price }}元</span
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">立即支付</el-button
              ><span v-if="false" style="color: red;margin: 0 0 0 16px;"
                >免费版用户不支持购买此服务，请先升级账户等级</span
              >
            </el-form-item>
          </el-form>
        </el-card>
        <el-card>
          <div slot="header">绑定记录</div>
          <!-- 表格 -->
          <el-row
            style="
              background-color: white;
              padding: 10px 10px 10px 10px;
              margin-top: -4px;
              line-height: 1;
            "
          >
            <el-col :span="24">
              <template>
                <el-table
                  v-loading="loading"
                  :data="tableData"
                  borderstyle="width: 100%"
                  border
                >
                  <el-table-column
                    prop="createTime"
                    label="操作时间"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="nickName"
                    label="操作人"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.nickName
                          ? scope.row.nickName
                          : scope.row.operNo
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="busiDomain"
                    label="绑定域名"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                      <span>{{
                        dictMap["check_status"][scope.row.checkStatus]
                      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination
                  style="margin: 8px 0 0 0"
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="loadList"
                />
              </template>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!-- 
        <div class="withdrawal el-main-border" style="margin-top: 25px">
            <el-row class="title" style="border-bottom: 1px solid gainsboro;margin-right: 15px;padding-bottom: 13px;margin-bottom: 20px;">
                <el-col >提现记录</el-col>
            </el-row>
           
        </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { getUserProfile } from "@/api/system/user"
import { getDomainList, addDomain } from "@/api/system/domain"
import { getConfigKey } from "@/api/system/config"

export default {
  components: { Breadcrumb },
  data() {
    return {
      user: {},
      loading: false,
      total: 0,
      tableData: [],
      dialogFormVisible: false,
      saveParams: {
        busiDomain: "",
      },
      queryParams: {
        type: "0",
        pageNum: 1,
        pageSize: 10,
      },
      withdrawType: "alipay",
      isSubmit: false,
      price: 0
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    this.getUser()
    this.loadList()
    this.getConfigKey()
  },
  methods: {
    //查询当前账户余额
    getUser() {
      getUserProfile({}).then((response) => {
        this.user = response.user
        this.user.balance = this.user.balance.toFixed(2)
      })
    },
    //获取当前账号查询提现记录
    loadList() {
      getDomainList(this.queryParams).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    //提现
    async submitForm() {
      try {
        if (this.isSubmit) {
          return
        }
        this.isSubmit = true
        if (this.saveParams.busiDomain == "") {
          this.msgError("请输入域名！")
          this.isSubmit = false
          return
        }

        let response = await addDomain(this.saveParams)
        if (response.code === 200) {
          this.saveParams.busiDomain = ""
          this.msgSuccess("申请已提交")
          this.loadList()
          this.getUser()
        } else {
          this.msgError("申请提交失败!")
        }
      } catch (error) {
        this.isSubmit = false
      } finally {
        this.isSubmit = false
      }
    },
    getConfigKey() {
      var _self = this
      getConfigKey("domain.pay.amount")
        .then((res) => {
          if (res.code == 200) {
            this.price = res.msg
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    handleJump(path) {
      this.$router.push({ path: path })
    },
  },
}
</script>

<style scope>
@import "../../../assets/css/iconfont/iconfont.css";

.create_role_form {
  margin: 15px 15px 0 15px;
}
.create_role_form .el-form-item {
  display: flex;
  margin-bottom: 15px !important;
}
.create_role_form .el-form-item .el-form-item__label {
  width: 100px;
  font-weight: 700;
}
.create_role_form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
}
.withdrawal {
  margin: 8px 0 0 0;
}
.withdrawal .title {
  font-size: 17px;
  font-weight: bold;
}
.withdrawal .message {
  background-color: white;
  padding: 10px;
  border: 1px solid #dcdcdc;
  margin: 0px 0 29px 19px;
  line-height: 30px;
}

.withdrawal .icon {
  font-size: 18px;
  margin-left: 5px;
}

.withdrawal .el-table--border td {
  border-right: 0 solid !important;
}

.withdrawal .el-input.is-disabled .el-input__inner {
  color: black;
}
</style>
